import styles from './Pill.module.css';

const Pill = ({ tone = 'neutral', children }) => (
    <span className={`${styles.pill} ${styles[tone]}`}>{children}</span>
);

export default Pill;
